module.exports = __webpack_public_path__ + "fonts/Manrope-400-cyrillic-ext1.64f66ba.woff2";